import { useState } from "react";

interface Props {
  onSubmit: (url: string) => void;
  loading?: boolean;
}

export default function UrlInput({ onSubmit, loading = false }: Props) {
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) {
      setError("Enter a URL to audit.");
      return;
    }
    // Loose validation; the worker re-validates.
    const candidate = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    try {
      const parsed = new URL(candidate);
      if (!parsed.hostname.includes(".")) {
        setError("That does not look like a valid domain.");
        return;
      }
    } catch {
      setError("That does not look like a valid URL.");
      return;
    }
    setError(null);
    onSubmit(candidate);
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-2xl">
      <div className="flex flex-col gap-2 sm:flex-row">
        <input
          type="text"
          inputMode="url"
          autoComplete="off"
          spellCheck={false}
          placeholder="https://yourdomain.com/page"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={loading}
          className="flex-1 rounded-lg border border-ink-200 bg-white px-4 py-3 text-ink-900 placeholder:text-ink-400 focus:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-200"
        />
        <button
          type="submit"
          disabled={loading}
          className="rounded-lg bg-ink-900 px-5 py-3 font-medium text-white transition-colors hover:bg-ink-700 disabled:cursor-not-allowed disabled:bg-ink-300"
        >
          {loading ? "Starting..." : "Run audit"}
        </button>
      </div>
      {error && <p className="text-red-600 mt-2 text-sm">{error}</p>}
    </form>
  );
}
